// temp: Fix finally to /static or something similar
// root of this url
const statusURLPrefix = '/';

export {
  // eslint-disable-next-line import/prefer-default-export
  statusURLPrefix,
};



// WEBPACK FOOTER //
// ./constants/urls.js